import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { TerritoryDetailScreen } from '../features/territories/TerritoryDetailScreen'

/** /territories/$id — детальная карточка одной территории (S40). */
export const Route = createFileRoute('/territories/$id')({
  component: TerritoryDetailRoute,
})

function TerritoryDetailRoute() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  return (
    <RequireAuth>
      <TerritoryDetailScreen territoryId={numericId} />
    </RequireAuth>
  )
}
